import {connect} from '@gisatcz/ptr-state';
import Action from '../../../../../../../../state/Action';
import Select from '../../../../../../../../state/Select';

import presentation from './presentation';

const mapStateToProps = state => {
	return {
		visualizations: Select.insar.visualizations.getActive(state),
	};
};

const mapDispatchToProps = dispatch => {
	return {
		handleNewIntervalSelect: interval => {
			dispatch(Action.insar.updateStylesWithSelectedInterval(interval));
			dispatch(Action.insar.setInterferometryMapLayerStyle());
		},
		handleVisualizationCustomInterval: interval => {
			dispatch(
				Action.insar.visualizations.handleVisualizationCustomInterval(interval)
			);
		},
		handleActiveVisualizationFilteredOutInterval: () => {
			dispatch(
				Action.insar.visualizations.handleActiveVisualizationFilteredOutInterval(
					[],
					true
				)
			);
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(presentation);
